import React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required, ArrayInput, SimpleFormIterator, ReferenceInput, SelectInput
} from 'react-admin';


const renderProfesional = (choice) => choice ? `${choice.nombres} - ${choice.apellidos} - ${choice.matricula}` : '';

const UserCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="username" validate={[required()]}/>
            <ReferenceInput source="matricula" reference="profesionales" label="resources.users.fields.matriculas">
                <SelectInput optionText={renderProfesional} optionValue="matricula"/>
            </ReferenceInput>
            <ArrayInput source="roles" addLabel={false}>
                <SimpleFormIterator >
                    <ReferenceInput source="roleId" reference="roles" label="resources.users.fields.roles" validate={[required()]} addLabel={false}>
                        <SelectInput optionText="description" optionValue="id"/>
                    </ReferenceInput>
                </SimpleFormIterator>
            </ArrayInput>
        </SimpleForm>
    </Create>
);

export default UserCreate;
